<template>
  <div>
    
    <!-- 提现方式 -->
    <el-dialog :title="$t('user_Index_TXFS')" v-dialogDrag   :visible.sync="cashmethodVis" :width="zhoren==='en'?'900px':'800px'" @close='close'>
      <el-form ref="withdrawal" :label-width="zhoren==='en'?'180px':'130px'" :rules='rules' :model="withdrawal" :inline="true">
        <!-- 支付宝收款码 -->
        <el-form-item   :label="$t('user_TX_ZFB')+'：'" prop="ali_img">
          <el-upload
            class="avatar-uploader"
            :action="$host.file+'/api/a_u/upload_file'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="withdrawal.ali_img" :src="$tool.src(withdrawal.ali_img)" title="点击更换收款码" oncontextmenu="return false;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
		  <!-- <el-input :placeholder="$t('输入姓名')" v-model="withdrawal.ali_pay_name"></el-input>
		   <el-input :placeholder="$t('输入账号')" v-model="withdrawal.ali_pay_account"></el-input> -->
        </el-form-item>
		<!--支付宝信息-->
		<div class="acc-info-box">
			<div>
				<el-form-item   :label="$t('支付宝姓名')+'：'" prop="payment_code">
				   <el-input v-model="withdrawal.ali_pay_name"></el-input>
				</el-form-item>
			</div>
			<div>
				<el-form-item   :label="$t('支付宝账号')+'：'" prop="payment_code">
				     <el-input v-model="withdrawal.ali_pay_account"></el-input>
				</el-form-item>
			</div>
		
		   
		</div>
		
        <!-- 微信收款码 -->
        <el-form-item   style="margin-left:20px" :label="$t('user_TX_WX')+'：'" prop="payment_code">
          <el-upload
            class="avatar-uploader"
            :action="$host.file+'/api/a_u/upload_file'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
            :before-upload="beforeAvatarUpload">
            <img v-if="withdrawal.wx_img" :src="$tool.src(withdrawal.wx_img)" title="点击更换收款码" oncontextmenu="return false;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
		<!--微信信息-->
		<div class="acc-info-box">
			<div>
				<el-form-item   :label="$t('微信姓名')+'：'" prop="payment_code">
				   <el-input v-model="withdrawal.wx_pay_name"></el-input>
				</el-form-item>
			</div>
			<div>
				<el-form-item   :label="$t('微信账号')+'：'" prop="payment_code">
				     <el-input v-model="withdrawal.wx_pay_account"></el-input>
				</el-form-item>
			</div>
		
		   
		</div>
		
		
        <!-- paypal -->
        <el-form-item   label="paypal：" prop="payment_code">
          <!-- <el-upload
            class="avatar-uploader"
            :action="$host.file+'/api/a_u/upload_file'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess2"
            :before-upload="beforeAvatarUpload">
            <img v-if="withdrawal.paypal" :src="picImg+withdrawal.paypal" oncontextmenu="return false;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload> -->
          <el-input v-model="withdrawal.paypal"></el-input>
        </el-form-item>
        <!-- veem -->
        <el-form-item   label="veem：" prop="payment_code">
          <!-- <el-upload
            class="avatar-uploader"
            :action="$host.file+'/api/a_u/upload_file'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess3"
            :before-upload="beforeAvatarUpload">
            <img v-if="withdrawal.veem" :src="picImg+withdrawal.veem" oncontextmenu="return false;" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload> -->
          <el-input v-model="withdrawal.veem"></el-input>
        </el-form-item>
        <!-- 收款卡号 -->
        <el-form-item :label="$t('user_TX_YHK')+'：'" prop="payment_code">
          <el-input type="number"  v-model="withdrawal.bank_card"></el-input>
          <!-- <div style="color:#fa7202;font-size:12px;">请细心填写，此卡号将作为提现收款账号</div> -->
        </el-form-item>
        <!-- 持卡人名称 -->
        <el-form-item :label="$t('user_TX_CKR')+'：'" prop="payment_code">
          <el-input v-model="withdrawal.bank_name"></el-input>
        </el-form-item>
        <!-- 开户行名称 -->
        <el-form-item :label="$t('user_TX_KHH')+'：'" prop="payment_code">
          <el-input v-model="withdrawal.open_bank"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cashmethodVis=false" class="button-radius-5px">{{$t('pay_qx')}}</el-button>
        <el-button type="primary" class="button-radius-5px" @click="Submission()">{{$t('user_Index_QD')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {bindCash } from "@/Inspector_api/index";
import check from "@/check/check";
export default {
  data() {
    return {
      userInfo:{},
      //提现
      cashmethodVis:false,
      withdrawal:{
        ali_img:'',
        wx_img:'',
        open_bank:'',
        bank_name:'',
        bank_card:'',
		wx_pay_name:"",
		wx_pay_account:"",
		ali_pay_name:"",
		ali_pay_account:"",
      },
      rules:{},
      zhoren:localStorage.getItem("locale")
    };
  },
  props:{
    showcashmethod:{default:false}
  },
  watch: {
    showcashmethod: {
      handler(val) {
        if(val==true){
          this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
          this.cashvisOpen()
        }        
        this.cashmethodVis=val        
      }
    },
  },
  methods: {  
    //弹窗关闭
    close(){      
      this.cashmethodVis = false
      this.$emit('close',{val:false,type:1})
      
    },  
    //上传图片成功
		handleAvatarSuccess(res, file,fileList) {
        this.withdrawal.ali_img=res.data.file_path
    },
    //上传图片成功
		handleAvatarSuccess1(res, file,fileList) {
        this.withdrawal.wx_img=res.data.file_path
    },
    handleAvatarSuccess2(res, file,fileList) {
        this.withdrawal.paypal=res.data.file_path
    },
    handleAvatarSuccess3(res, file,fileList) {
        this.withdrawal.veem=res.data.file_path
    },
    
		//上传图片之前
		beforeAvatarUpload(file) {
				const isLt30M = file.size / 1024 / 1024 < 30;
				if (!isLt30M) {
					this.$message.error(this.$t('user_Index_SC30'));
        }
				return  isLt30M;	
		},
    // 提现弹窗
    cashvisOpen(){
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      console.log(this.userInfo)
      
      this.withdrawal={
        ali_img:this.userInfo.ali_img?this.userInfo.ali_img:'',
        wx_img:this.userInfo.wx_img?this.userInfo.wx_img:'',
        paypal:this.userInfo.paypal?this.userInfo.paypal:'',
        veem:this.userInfo.veem?this.userInfo.veem:'',
        open_bank:this.userInfo.open_bank?this.userInfo.open_bank:'',
        bank_name:this.userInfo.bank_name?this.userInfo.bank_name:'',
        bank_card:this.userInfo.bank_card?this.userInfo.bank_card:'',
		wx_pay_name:this.userInfo.wx_pay_name,
		wx_pay_account:this.userInfo.wx_pay_account,
		ali_pay_name:this.userInfo.ali_pay_name,
		ali_pay_account:this.userInfo.ali_pay_account,
      }
      console.log(this.withdrawal)
    },
    //确 定
    async Submission(){
      // if(this.userInfo.amount_type==2){
        //  delete this.withdrawal.ali_img
        //  delete this.withdrawal.wx_img
      // }
      let isEmpty = false //判断是否填了付款方式
      for(let key of Object.keys(this.withdrawal)){
        if(this.withdrawal[key] != ''){
          isEmpty = true
        }
      }
      if(!isEmpty){
        this.$message.error($t('ty_txfs'))
        return
      } 
      
      const res = await bindCash(this.withdrawal);
      const { code, data,msg } = res.data;
      if (code == 200) {
        this.$message.success(msg)
        this.cashmethodVis=false
        this.$emit('closeCashmethod',{val:this.cashmethodVis,type:2})
      }
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.cashvisOpen()
    this.cashmethodVis=this.showcashmethod        
  },
  mounted(){
  }
};
</script>


<style lang="scss" scoped>
.org {
  color: $--color-primary;
}
.borwn {
  color: #90613a;
}
.title /deep/ .el-card__body{
  padding: 12px;
}
.amount /deep/ .el-card__body{
  padding: 10px;
}
.levelInfo /deep/ .el-card{
  height: 110px;
}
/deep/ .subMenu{
  background-color: #ffffff;
}
.amap-wrapper {
  width: 99%;
  height: 400px;
}
</style>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .acc-info-box{
	  display:inline-block;
  }
</style>